module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "dropdown",
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-flex magic-button p-relative"
  }, [_c('BellIcon', {
    staticClass: "cursor-pointer p-1 br-1 magic-button",
    class: {
      'bg-danger wiggle': _vm.unreadNoficationsCount > 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDropDown = !_vm.showDropDown
      }
    }
  })], 1), _vm._v(" "), _c('TransitionFade', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropDown),
      expression: "showDropDown"
    }],
    staticClass: "p-absolute"
  }, [_c('div', {
    staticClass: "better-navbar-dropdown is-active moreDropdown "
  }, [_c('div', {
    staticClass: "d-flex justify-space-between align-items-center mb-2"
  }, [_c('div', {
    staticClass: "d-flex flex-align-center flex-wrap"
  }, [_c('h3', {
    staticClass: "fs-6 mr-2"
  }, [_vm._v("Notifications")]), _vm._v(" "), (!_vm.loading) ? _c('small', {
    staticClass: "fs-4",
    class: {
      'text-danger': _vm.unreadNoficationsCount > 0
    }
  }, [_vm._v("\n              (" + _vm._s(_vm.unreadNoficationsCount) + " unread)\n            ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unreadNoficationsCount > 0 && !_vm.loading),
      expression: "unreadNoficationsCount > 0 && !loading"
    }],
    staticClass: "button is-small",
    class: {
      'is-loading': _vm.dismissing
    },
    on: {
      "click": function($event) {
        _vm.clearNotifications()
      }
    }
  }, [_vm._v("\n            mark all read\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "delete ml-2",
    on: {
      "click": function($event) {
        _vm.showDropDown = false
      }
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('Loader') : (_vm.notifications.length > 0) ? _c('section', {
    staticClass: "overflow-y-after-600px"
  }, _vm._l((_vm.notifications), function(notif) {
    return _c('Notification', {
      key: notif.id,
      attrs: {
        "notification": notif
      }
    })
  })) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4a23ed34"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavbarNotifications.vue
// module id = 1026
// module chunks = 0